import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addServiceStart, fetchServicesStart, deleteServiceStart } from './../redux/VendorServices/vendor.actions';
import { fetchProductsStart } from './../redux/Products/products.actions';
import Modal from './../components/Modal';
import Button from './../components/forms/Button';


const mapState = ({ productsData, vendorsData, user }) => ({
  products: productsData.products,
  services: vendorsData.services,
  currentUser: user.currentUser
});


const VendorServicesDetails = props => {
	const { products, services, currentUser } = useSelector(mapState);
	const dispatch = useDispatch();
	const [hideModal, setHideModal] = useState(true);
	const [productName, setProductName] = useState('HVAC Filter Replacement')
	;
	const [vendorName, setVendorName] = useState(currentUser.displayName);
	const [vendorPhone, setVendorPhone] = useState(currentUser.phone);
	const [vendorEmail, setVendorEmail] = useState(currentUser.email);
	const [vendorID, setVendorID] = useState(currentUser.id);
	

	const { data} = products;
	const { serviceData } = services;
	

	
	useEffect(() => {
		dispatch(
			fetchServicesStart()
		);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		dispatch(
			fetchProductsStart()
		);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
			window.scrollTo(0, 0)
		}, [])

	//create and filter array
	let payPerServiceArray = [];
	if(Array.isArray(data)){
		for(let i = 0; i < data.length; i++){
			if(data[i].productCategory === "Vendor Service"|| data[i].productCategory === "Vendor Pay-Per Service"){
				payPerServiceArray.push(data[i]);
			}
		}
	}

	//create and filter array to show only services not selected
	let filteredServiceArry = payPerServiceArray.filter(item1 => 
	!serviceData.some(item2 => (item2.productName === item1.productName)))

	

	const toggleModal = () => setHideModal(!hideModal);

	const configModal = {
		hideModal,
		toggleModal
	};

	const resetForm = () => {
		setHideModal(true);
		setProductName('HVAC Filter Replacement');
		setVendorName(currentUser.displayName);
		setVendorPhone(currentUser.phone);
		setVendorEmail(currentUser.email);
		setVendorID(currentUser.id);
	};


	const handleSubmit = e => {
		e.preventDefault();

		dispatch(
			addServiceStart({
				productName,
				vendorName,
				vendorPhone,
				vendorEmail,
				vendorID
		})
		);
		resetForm();

	};

	return (
		<div className="vendor">

		<div className="vendorCallToActions row text-center pt-5">
			<ul>
			<li>
				<Button  className="venServBtn" onClick={() => toggleModal()}>
				Add New Service
				</Button>
			</li>
			</ul>
		</div>

		<Modal {...configModal}>
			<div className="addNewProductForm">
			<form onSubmit={handleSubmit}>

				<h2>
				Select a Service Offered
				</h2>
					
				<select name="services"  onChange={e => setProductName(e.target.value)}>
					{(Array.isArray(filteredServiceArry) && filteredServiceArry.length > 0) && filteredServiceArry.map((product, index) => {
					const {
						productName
					} = product;
					
					return (
					    <option value={productName} name={productName} key={index}>
						    {productName}
						</option>
						
					)
					
					})}
					
				</select>
	
				<br />
				<br />

				<Button type="submit">
				Add Service
				</Button>

			</form>
			</div>
		</Modal>
		
		<div className="vendorManageServices ">

			<table border="0" cellPadding="0" cellSpacing="0">
			<tbody>
				<tr className="text-center">
				<th>
					<h1>
					Manage Services
					
					</h1>
					<hr></hr>
				</th>
				</tr>
				<tr>
				<td>
					<table className="results" border="0" cellPadding="10" cellSpacing="0">
					<tbody>
					
						{(Array.isArray(serviceData) && serviceData.length > 0) && serviceData.map((product, index) => {
						const {
							productName,
							documentID
						} = product;
						
						return (
							<tr key={index}>
							<td>
								{productName}
							</td>
							<td>
								<Button onClick={() => dispatch(deleteServiceStart(documentID))}>
								Delete
								</Button>
											
							</td>
							</tr>
						)
						})}
					</tbody>
					</table>
				</td>
				</tr>
				<tr>
				<td>

				</td>
				</tr>
				
			</tbody>
			</table>

		</div>

		</div>
	);
}

export default VendorServicesDetails;